import { Validation, ValidationResult } from "./Validation";

/**
 * Ein einzelnes Bild für eine Veranstaltung.
 */
export default interface EventImageJson {
    ID: number | null;

    /**
     * Soll dieses Bild als Titelbild genutzt werden.
     */
    isMainImage: boolean;

    /**
     * Nummer, die die Reihenfolge im Fall von mehreren Bilder bestimmt. Nur positive Zahlen erlaubt.
     */
    order: number;

    /**
     * Alt-Text (Bildbeschreibung) für Barrierefreiheit.
     */
    altText: string;

    /**
     * Bild als Data-URL (oder Link zum Bild). Maximalgröße 10 MB für DataURLs.
     */
    url: string;
}

export let dataUrlJpegPrefix = "data:image/jpeg;base64,";
export let imageDataUrlMaxLength = dataUrlJpegPrefix.length + (1024 * 1024 * 10 * 8 / 6); // 22 Zeichen Data URL Start, Limit 10 Megabyte, 6 bits pro Zeichen

export function defaultEventImageJson() {
    return {
        ID: null,
        isMainImage: false,
        order: 0,
        altText: "",
        url: ""
    }
}

export function validateEventImageJson(json: EventImageJson): ValidationResult<EventImageJson> {
    return new Validation(json)
        .validateInteger("ID", 0, null, true)
        .validateInteger("order", 0, 999)
        .validateString("altText", 500)
        .validateString("url", imageDataUrlMaxLength)
        .finish();
}
export function validateEventImageJsonAdd(json: EventImageJson): ValidationResult<EventImageJson> {
    return new Validation(json)
        .validateEquals("ID", null)
        .validateInteger("order", 0, 999)
        .validateString("altText", 500)
        .validateString("url", imageDataUrlMaxLength)
        .finish();
}